import { Col, Container, Row, Stack } from "react-bootstrap";
import { renderSortIcon } from "../helperRenders";

export default function SongsHeader({
    sortConfig,
    requestSort,
    showSpins = false,
    showReleaseYear = false,
    showFirstOn = false,
    showFirstPlay = false,
    showTrend = false,
    firstPlayColXl = 1,
    firstPlayColXs = 2,
}) {
    return (
        <Container fluid className="sticky-top">
            <Row className="bg-ra-dark-blue text-white fw-bold py-1 rounded-2 fs-8-xs table-header user-select-none h-100">
                <Col onClick={() => requestSort("artist")} className=" align-content-center">
                    <Stack direction="horizontal">
                        <span>Artist</span>
                        <span className="col-1">{renderSortIcon("artist", sortConfig)}</span>
                    </Stack>
                </Col>
                <Col onClick={() => requestSort("title")} className=" align-content-center">
                    <Stack direction="horizontal">
                        <span>Title</span>
                        <span className="col-1">{renderSortIcon("title", sortConfig)}</span>
                    </Stack>
                </Col>
                {showReleaseYear && (
                    <Col xs={2} xl={2} onClick={requestSort ? () => requestSort("release_year") : null} className=" align-self-center">
                        <Stack direction="horizontal" className="justify-content-center">
                            <span className="offset-1 text-center">Release Year</span>
                            <span className="col-1">{renderSortIcon("release_year", sortConfig)}</span>
                        </Stack>
                    </Col>
                )}
                {showSpins && (
                    <Col xs={2} xl={1} onClick={requestSort ? () => requestSort("spins") : null} className=" align-self-center">
                        <Stack direction="horizontal" className="justify-content-center">
                            <span className="offset-1">Spins</span>
                            <span className="col-1">{renderSortIcon("spins", sortConfig)}</span>
                        </Stack>
                    </Col>
                )}
                {showFirstPlay && (
                    <Col xs={firstPlayColXs} xl={firstPlayColXl} onClick={requestSort ? () => requestSort("first_play") : null} className=" align-self-center">
                        <Stack direction="horizontal" className="justify-content-center">
                            <span className="offset-1 text-center">First Played</span>
                            <span className="col-1">{renderSortIcon("first_play", sortConfig)}</span>
                        </Stack>
                    </Col>
                )}
                {showFirstOn && (
                    <Col xs={2} xl={2} onClick={requestSort ? () => requestSort("first_on") : null} className=" align-self-center d-none d-xl-block">
                        <Stack direction="horizontal" className="justify-content-center text-center">
                            <span className="offset-1 text-center">First on</span>
                            <span className="col-1">{renderSortIcon("first_on", sortConfig)}</span>
                        </Stack>
                    </Col>
                )}
                {showTrend && (
                    <Col xs={2} xl={2} onClick={requestSort ? () => requestSort("trend") : null} className=" align-self-center">
                        <Stack direction="horizontal" className="justify-content-center text-center">
                            <span className="offset-1">Trend</span>
                            <span className="col-1">{renderSortIcon("trend", sortConfig)}</span>
                        </Stack>
                    </Col>
                )}
            </Row>
        </Container>
    );
}
